<template>
  <div id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">
        <div class="xblock layui-form">
          <button class="layui-btn xblock-row" lay-filter="sreach" v-on:click="ShowModel()">套餐设置</button>
          <span class="x-right xblock-row" v-text="'　共有数据：'+count+ '条'"></span>
          <div class="clear-both"></div>
        </div>

        <table class="layui-table">
          <thead>
            <tr>
              <th>类型</th>
              <th>编号</th>
              <th>名称</th>
              <th>价格</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in list">
              <td>
                <i v-if="item.package_item_type == 1">VIP服务</i>
                <i v-else-if="item.package_item_type == 2">资源包</i>
                <i v-else>空间扩容</i>
              </td>
              <td v-text="item.ids"></td>
              <td v-text="item.name"></td>
              <td v-text="item.money"></td>
              <td class="btn-arr">
                <button class="layui-btn" v-on:click="ShowModel(item)">编辑</button>
                <button class="layui-btn layui-btn-danger" v-on:click="ConfirmHint(1,item)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

      </div>

    </div>

    <!-- 分页 -->
    <div class="page-box">
      <div id="pagebox" class="pagebox"></div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </div>
</template>

<script>
  var self, form, layer, laypage, VipBox, OneXml = "",
    TwoXml = "",
    ThreeXml = "",
    FourXml = "",
    FiveXml = "",
    SixXml = "";
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Pricing',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        item: null,
        isLoding: true,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        total: 0,
        page_num: 20,
        current_status: 0,
        status_id: 0,
        list: [],
        package: [],
        data_total: {
          amount_invested: 0,
          escrow_amount: 0,
          total_amount: 0,
          profit: 0,
          profit_margin: 0
        },
        status: [{
          id: 1,
          name: "打包"
        }]
      }
    },
    mounted() {
      self = this;
      layui.use(['form', 'layer', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;

        //套餐次数
        form.on('radio(PackageType)', function(data) {
          if (data.value == 1) {
            $("#package_level_one").html(OneXml);
            $("#package_level_two").html(TwoXml);
          } else if (data.value == 2) {
            $("#package_level_one").html(ThreeXml);
            $("#package_level_two").html(FourXml);
          } else if (data.value == 3) {
            $("#package_level_one").html(FiveXml);
            $("#package_level_two").html(SixXml);
          }
          form.render();
        });

        //店铺类型
        form.on('checkbox(shop-count)', function(data) {
          var child = $(".shop-count input[type='checkbox']");
          var status = data.elem.checked;
          child.each(function(index, item) {
            item.checked = false;
          });
          data.elem.checked = true;
          form.render();
        });

        //购买周期
        form.on('checkbox(vip-date)', function(data) {
          var child = $(".vip-date input[type='checkbox']");
          var status = data.elem.checked;
          child.each(function(index, item) {
            item.checked = false;
          });
          data.elem.checked = true;
          form.render();
        });

        self.GetList()
        self.GetPackage();
      });
    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      ConfirmHint(te, item) {
        self.Confirm.style = te;
        self.Confirm.state = true;
        self.Confirm.txt = "是否确认删除？"
        self.item = item;
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {
          self.loading = true;
          self.Confirm.state = false;
          let param = new URLSearchParams()
          param.append('ids', self.item.ids)
          self.loading = true;
          axios({
            method: 'post',
            url: self.GetServerUrl() + "/package_del/",
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              self.GetList();
            }, false, true);

          }).catch(function(error) {
            self.loading = false;
            console.log(error);
          })


        }
      },
      GetList() {
        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        axios({
          method: 'post',
          data: param,
          url: self.GetServerUrl() + "/package/?page=" + self.page,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            if (datas.page) {
              self.list = datas.list;
              self.total = datas.total;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "GetList"); //分页
              $('.pagebox').show();
            }
          }, function() {
            self.list = [];
            $('.pagebox').hide();

            //自动换页
            if (self.page > 1) {
              self.page -= 1;
              self.GetList();
            }
          });

        }).catch(function(error) {
          self.isLoding = false;
          console.log(error);
        })
      },
      GetPackage() {
        self.isLoding = true;
        axios({
          method: 'get',
          url: self.GetServerUrl() + "/package_item/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            OneXml = "", TwoXml = "", ThreeXml = "", FourXml = "", FiveXml = "", SixXml = "";
            var PackageDatas = datas.package_item;
            for (let x in PackageDatas) {
              for (let y in PackageDatas[x]) {
                for (let z in PackageDatas[x][y]) {
                  if (x == 1 && y == 1) {
                    OneXml += '<option value="' + PackageDatas[x][y][z].id + '">' + PackageDatas[x][y][z].name +
                      '</option>'
                  } else if (x == 1 && y == 2) {
                    TwoXml += '<option value="' + PackageDatas[x][y][z].id + '">' + PackageDatas[x][y][z].name +
                      '</option>'
                  } else if (x == 2 && y == 1) {
                    ThreeXml += '<option value="' + PackageDatas[x][y][z].id + '">' + PackageDatas[x][y][z]
                      .name + '</option>'
                  } else if (x == 2 && y == 2) {
                    FourXml += '<option value="' + PackageDatas[x][y][z].id + '">' + PackageDatas[x][y][z]
                      .name + '</option>'
                  } else if (x == 3 && y == 1) {
                    FiveXml += '<option value="' + PackageDatas[x][y][z].id + '">' + PackageDatas[x][y][z]
                      .name + '</option>'
                  } else if (x == 3 && y == 2) {
                    SixXml += '<option value="' + PackageDatas[x][y][z].id + '">' + PackageDatas[x][y][z].name +
                      '</option>'
                  }
                }
              }
            }
          }, false, false);

        }).catch(function(error) {
          self.isLoding = false;
          console.log(error);
        })
      },
      ShowModel(datas) {
        var w, h;
        if (w == null || w == '') {
          w = $(window).width() - 260;
          if (w > 500) {
            w = 500;
          }
        };
        if (h == null || h == '') {
          h = $(window).height() - 200;
          if (h > 410) {
            h = 410;
          }
        };
        VipBox = layer.open({
          type: 1,
          offset: '100px',
          title: "套餐设置",
          area: [w + 'px', h + 'px'],
          fixed: false, //不固定
          btn: ['确定'],
          content: PackageSet,
          success: function() {
            $("#package_level_one").html(OneXml);
            $("#package_level_two").html(TwoXml);
            if (datas) {
              $("#PackageType input[name=PackageType][value=" + datas.package_item_type + "]").prop("checked",
                "true");
              if ($('#PackageType input[name="PackageType"]:checked').val() == 2) {
                $("#package_level_one").html(ThreeXml);
                $("#package_level_two").html(FourXml);
              } else if ($('#PackageType input[name="PackageType"]:checked').val() == 3) {
                $("#package_level_one").html(FiveXml);
                $("#package_level_two").html(SixXml);
              }
              if (datas.ids) {
                let ids = datas.ids.split(',');
                $("#package_level_one").val(ids[0]);
                $("#package_level_two").val(ids[1]);
              }
              $("#PackagePrice").val(datas.money);
            }

            form.render();
          },
          yes: function(index, layero) {
            var stutas = $('#PackageType input[name="PackageType"]:checked').val();
            var oneId = $("#package_level_one").val();
            var oneName = $("#package_level_one").find("option:selected").text();
            var twoId = $("#package_level_two").val();
            var twoName = $("#package_level_two").find("option:selected").text();
            var PackagePrice = $("#PackagePrice").val();
            let param = new URLSearchParams()

            if (!PackagePrice) {
              layer.msg("价格不能为空！");
              return;
            }
            if (!oneId) {
              layer.msg("名称不能为空！");
              return;
            }
            if (!twoId) {
              layer.msg("内容不能为空！");
              return;
            }

            param.append('package_item_type', stutas);
            param.append('ids', oneId + "," + twoId);
            param.append('money', PackagePrice);
            param.append('name', oneName + "," + twoName);

            self.loading = true;
            axios({
              method: 'post',
              url: self.GetServerUrl() + "/store_package/",
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(response) {

              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                layer.close(VipBox);
                self.GetList();
              }, false, true);

            }).catch(function(error) {
              self.loading = false;
              console.log(error);
            })

          }
        });
      },
      EditItem(item) {
        self.item = item;
        self.modal_box_show(self, 'Pricing', "编辑定价模板", item);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/product/PackageSet.vue